import comp from './AsyncLoading';
export default comp;
